import { UniDriver } from '@wix/unidriver-core';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';
import { buttonCoreDriverFactory } from '../Button/ButtonCore/ButtonCore.uni.driver';

const splitActionButtonDriverFactory = (base: UniDriver) => {
  const { click, getButtonTextContent, isButtonDisabled } =
    buttonCoreDriverFactory(base);

  return {
    ...baseUniDriverFactory(base),
    /** Clicks the button */
    click,
    /** Gets the text content of the button */
    getText: getButtonTextContent,
    /** Checks whether the button is disabled */
    isDisabled: isButtonDisabled,
  };
};

export const splitActionDriverFactory = (base: UniDriver) => {
  const buttons = base.$$('[data-split-action-button]');

  return {
    ...baseUniDriverFactory(base),
    exists: () => base.exists(),
    /** Gets the number of buttons */
    getButtonCount: () => buttons.count(),

    /** Returns the driver for the button at the given index */
    getButton: (index: number) =>
      splitActionButtonDriverFactory(buttons.at(index)),
  };
};

export type SplitActionButtonUniDriver = ReturnType<
  typeof splitActionButtonDriverFactory
>;
export type SplitActionUniDriver = ReturnType<typeof splitActionDriverFactory>;

export default splitActionDriverFactory;
